import SetPasswordForm from './Form'
export default SetPasswordForm
